/* ===================================================================
   VENTEGA — MONOCHROME EDITION
   Micro-interactions + scroll motion.
   Scripts are loaded with defer, so the DOM is already parsed by the
   time this runs — no DOMContentLoaded wrapper needed.
   =================================================================== */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollReveal() {
    var candidates = document.querySelectorAll('.card-wrapper, .hype-packaging__card');
    var targets = Array.prototype.filter.call(candidates, function (el) {
      return !el.closest('.hype-hero-split');
    });

    if (!targets.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('hype-in-view');
      });
      return;
    }

    targets.forEach(function (el, index) {
      el.classList.add('hype-observe');
      el.style.transitionDelay = (index % 4) * 80 + 'ms';
    });

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hype-in-view');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initCursorLabel() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var label = document.querySelector('.hype-cursor-label');
    var cards = document.querySelectorAll('.card-wrapper');
    if (!label || !cards.length) return;

    var visible = false;
    var mouseX = 0;
    var mouseY = 0;

    function moveLabel() {
      label.style.transform = 'translate(' + mouseX + 'px, ' + mouseY + 'px)';
    }

    document.addEventListener('mousemove', function (event) {
      mouseX = event.clientX;
      mouseY = event.clientY;
      if (visible) window.requestAnimationFrame(moveLabel);
    });

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        visible = true;
        label.classList.add('is-visible');
      });
      card.addEventListener('mouseleave', function () {
        visible = false;
        label.classList.remove('is-visible');
      });
    });
  }

  function initBackToTop() {
    var button = document.querySelector('.hype-back-to-top');
    if (!button) return;

    var threshold = 600;

    function toggleVisibility() {
      if (window.scrollY > threshold) {
        button.classList.add('is-visible');
      } else {
        button.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  initScrollReveal();
  initCursorLabel();
  initBackToTop();
})();
